import { render, staticRenderFns } from "./routers.vue?vue&type=template&id=683377b2&"
import script from "./routers.vue?vue&type=script&lang=js&"
export * from "./routers.vue?vue&type=script&lang=js&"
import style0 from "./routers.vue?vue&type=style&index=0&id=683377b2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports